import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { AiOutlinePlus } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../../Components/Header/Header";
import MetaData from "../../../../Components/MetaData";
import {
  getCurrentUserLoanRequests,
  indivisualLoanRequestDeleted,
} from "../../../../Redux/Actions/LoanRequests";
import MuiDataTable from "../../../../Components/MUIDataTable/MUIDataTable";
import Loader from "../../../../Utils/Loader";
import { Typography } from "@mui/material";
import { FaEye } from "react-icons/fa";
import { BsTrashFill } from "react-icons/bs";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { errorNotify, successNotify } from "../../../../Utils/toast";
import { useStyle } from "../../../HR/Pages/Attendance/attendance-styles";
import AddLoanRequestModal from "../../../HR/Pages/LoanRequestModule/AddLoanRequestModal";
import DeleteConfirmModal from "../../../../Components/DeleteConfirmModal/DeleteConfirmModal";
import {
  formatAmountLeftTableDisplay,
  formatAmountPaidTableDisplay,
  formatRsTable,
  getLoanRowStatus,
} from "../../../HR/Pages/LoanRequestModule/loanRequestUtils";

const formatRs = formatRsTable;

const centeredColumnOptions = {
  setCellProps: () => ({
    style: {
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
    },
  }),
  setCellHeaderProps: () => ({ style: { textAlign: "center" } }),
};

const EmployeeLoanRequests = () => {
  const [addModal, setAddModal] = useState(false);
  const [show, setShow] = useState(false);
  const [loanId, setLoanId] = useState("");
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(5);
  const classes = useStyle();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, loans, loanCount } = useSelector(
    (state) => state.currentUserLoanRequest,
  );
  const { success } = useSelector((state) => state.createLoanRequest);
  const {
    deleted,
    loading: deleteLoading,
    error: deleteError,
  } = useSelector((state) => state.deleteLoanRequest);

  useEffect(() => {
    dispatch(getCurrentUserLoanRequests(page, size));
  }, [page, size]);

  useEffect(() => {
    if (success) {
      setAddModal(false);
      dispatch(getCurrentUserLoanRequests(page, size));
    }
    if (deleted?.success) {
      successNotify(deleted?.message);
      setShow(false);
      dispatch({ type: "INDIVISUAL_LOAN_REQUEST_DELETE_RESET" });
      dispatch(getCurrentUserLoanRequests(page, size));
    }
    if (deleteError) {
      errorNotify(deleteError);
      dispatch({ type: "CLEAR_ERRORS" });
    }
  }, [success, deleted?.success, deleteError]);

  const handleLoanDeleteClick = (deleteId) => {
    setLoanId(deleteId);
    setShow(true);
  };


  const columns = [
    { name: "_id", options: { display: false } },
    {
      name: "applied_date",
      label: "Applied Date",
      options: {
        ...centeredColumnOptions,
        customBodyRender: (value) => (
          <Typography className="fs-12" sx={{ width: "100%", textAlign: "center" }}>
            {value ? moment(value).format("DD-MM-YYYY") : "-"}
          </Typography>
        ),
      },
    },
    {
      name: "amount",
      label: "Amount (Rs)",
      options: {
        ...centeredColumnOptions,
        customBodyRender: (value) => (
          <Typography className="fs-12" sx={{ width: "100%", textAlign: "center" }}>
            {formatRs(value)}
          </Typography>
        ),
      },
    },
    {
      name: "amount_paid",
      label: "Amount Paid (Rs)",
      options: {
        ...centeredColumnOptions,
        customBodyRender: (value, tableMeta) => (
          <Typography
            className="fs-12"
            sx={{ width: "100%", textAlign: "center", color: "success.main" }}
          >
            {formatAmountPaidTableDisplay(
              value,
              getLoanRowStatus(tableMeta, 5),
            )}
          </Typography>
        ),
      },
    },
    {
      name: "amount_left",
      label: "Amount Left (Rs)",
      options: {
        ...centeredColumnOptions,
        customBodyRender: (value, tableMeta) => (
          <Typography
            className="fs-12"
            sx={{ width: "100%", textAlign: "center", color: "error.main" }}
          >
            {formatAmountLeftTableDisplay(
              value,
              getLoanRowStatus(tableMeta, 5),
            )}
          </Typography>
        ),
      },
    },
    {
      name: "hr_status",
      label: "Status",
      options: {
        customBodyRender: (value) => (
          <Typography
            className={`${
              value === "approved"
                ? classes.present
                : value === "rejected"
                  ? classes.absent
                  : classes.halfDay
            }`}
            sx={{ fontSize: "10px", fontWeight: "600" }}
          >
            {value || "-"}
          </Typography>
        ),
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowId = tableMeta.rowData[0];
          const row = loans?.find((l) => l._id === rowId);
          return (
            <div className="leaves_management_btn_container">
              <button
                className="edit_btn"
                type="button"
                onClick={() => navigate(`/employee/loan-request/${rowId}`)}
              >
                <FaEye />
              </button>
              {row?.hr_status === "pending" && (
                <button
                  className="delete_btn"
                  type="button"
                  onClick={() => handleLoanDeleteClick(rowId)}
                >
                  <BsTrashFill />
                </button>
              )}
            </div>
          );
        },
      },
    },
  ];

  return (
    <div className="page_responsive">
      <DeleteConfirmModal
        show={show}
        onClose={() => setShow(false)}
        onConfirm={() => dispatch(indivisualLoanRequestDeleted(loanId))}
        loading={deleteLoading}
        message="Are u sure you want to delete this loan request?"
      />
      <Header title="Loan Requests" />
      <MetaData title="Loan Requests -- HRM" />
      <Container fluid>
        <Row className="m-0">
          <Col md={12}>
            <div className="employees_main_selection">
              <Form>
                <Row className="align-items-end justify-content-end">
                  <Col md={6} className="d-flex gap-3 justify-content-end">
                    <div
                      className="add_employees_btn_container"
                      style={{ width: "fit-content" }}
                    >
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setAddModal(true);
                        }}
                      >
                        <AiOutlinePlus /> Apply for Loan
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
          <Col md={12}>
            {loading ? (
              <Loader />
            ) : (
              <div className="tickets_management_table">
                <MuiDataTable
                  title="MY LOAN REQUESTS"
                  columns={columns}
                  data={loans || []}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={size}
                  setRowsPerPage={setSize}
                  count={loanCount}
                  tableId="employee_loan_requests_table"
                />
              </div>
            )}
          </Col>
        </Row>
      </Container>
      <AddLoanRequestModal
        modalOpen={addModal}
        setModalOpen={setAddModal}
        onSuccess={() => dispatch(getCurrentUserLoanRequests(page, size))}
      />
    </div>
  );
};

export default EmployeeLoanRequests;
